import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02d96b7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-content-photos mr-2" }
const _hoisted_2 = { class: "invoice-content-photos__preview" }
const _hoisted_3 = { class: "preview__container" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "invoice-content-photos__container" }
const _hoisted_12 = { class: "container__preview" }
const _hoisted_13 = ["src", "onClick"]
const _hoisted_14 = { class: "container__wrap" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "container__list" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "preview__background",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePreview && _ctx.closePreview(...args)))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "container__preview",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPreview(_ctx.currentPhoto)))
        }, [
          _createElementVNode("button", {
            class: "preview__button button--left",
            type: "button",
            disabled: _ctx.currentPhoto === 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPrevious && _ctx.onPrevious(...args)))
          }, _hoisted_6, 8, _hoisted_4),
          _createElementVNode("button", {
            class: "preview__button button--right",
            type: "button",
            disabled: _ctx.currentPhoto === _ctx.photos.length - 1,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
          }, _hoisted_9, 8, _hoisted_7),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("img", {
              key: photo,
              src: photo
            }, null, 8, _hoisted_10)), [
              [_vShow, _ctx.currentPhoto === i]
            ])
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isPreviewOpened]
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo, i) => {
          return _withDirectives((_openBlock(), _createElementBlock("img", {
            key: photo,
            src: photo,
            onClick: ($event: any) => (_ctx.openPreview(i))
          }, null, 8, _hoisted_13)), [
            [_vShow, _ctx.currentPhoto === i]
          ])
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "wrap__button button--left",
          type: "button",
          disabled: _ctx.currentPhoto === 0,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onPrevious && _ctx.onPrevious(...args)))
        }, _hoisted_17, 8, _hoisted_15),
        _createElementVNode("button", {
          class: "wrap__button button--right",
          type: "button",
          disabled: _ctx.currentPhoto === _ctx.photos.length - 1,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
        }, _hoisted_20, 8, _hoisted_18),
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["list__item", { 'item--active': _ctx.currentPhoto === i }]),
              key: `photo-${i}`,
              ref_for: true,
              ref: el => el && (_ctx.photoItems[i] = el as HTMLElement),
              onClick: ($event: any) => (_ctx.openPreview(i))
            }, [
              _createElementVNode("img", { src: photo }, null, 8, _hoisted_23)
            ], 10, _hoisted_22))
          }), 128))
        ])
      ])
    ])
  ]))
}